<template>
  <div>
    <van-button @click="show">加點</van-button>
    <van-popup v-model="visible" position="bottom">
      <van-sticky>
        <van-nav-bar
          :title="obj.TblName"
          left-text="返回"
          right-text="清除"
          left-arrow
          @click-left="visible = false"
          @click-right="clear"
        />
      </van-sticky>
      <div class="main">
        <!-- {{ ordertmp }} -->
        <van-grid :column-num="columnNum" clickable>
          <van-grid-item
            v-for="(n, index) in ordertmp"
            :key="index + n.ItemName"
            icon="photo-o"
            :text="'#' + (index + 1)"
          >
            <MenuPick
              :item="n"
              :title="'#' + (index + 1)"
              @add="
                (pObj) => {
                  setItem(index, pObj);
                }
              "
            />
          </van-grid-item>
        </van-grid>
        <!-- <van-row gutter="8">
          <van-col
            span="8"
            v-for="(n, index) in ordertmp"
            :key="index + n.ItemName"
            style="margin-bottom: 2rem"
          >
            <MenuPick
              :item="n"
              :title="'#' + (index + 1)"
              @add="
                (pObj) => {
                  setItem(index, pObj);
                }
              "
            />
          </van-col>
        </van-row> -->

        <!-- <van-button @click="$emit('send', obj.TblName, ordertmp)"> 確認傳送 </van-button> -->
        <van-button @click="send(obj.TblName, ordertmp)" :disabled="!hasData()">
          {{ getBtnText() }}
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<style scoped>
.van-row {
  margin: 0.4rem;
}
.el-button {
  color: #5237eb;
  font-size: 1rem;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 5rem;
}
.font-x2 {
  font-size: 2rem;
}
.font-x3 {
  font-size: 3rem;
  padding: 2rem;
}
.font-x4 {
  font-size: 4rem;
  margin: 1rem;
}
.main {
  text-align: center;
  font-size: 1rem;
  /* line-height: 2rem; */
  /* padding-top: 2rem; */
}
.title {
  text-align: center;
  font-weight: bold;
  line-height: 3rem;
  background-color: #c9d7f54d;
}
</style>

<script>
import MenuPick from "./Popup/FrmMenuPick.vue";
// import Footer from "./Popup/Child/Footer.vue";
export default {
  components: { MenuPick },
  props: {
    obj: Object,
    custTotal: Number,
  },
  data() {
    return {
      visible: false,
      title: "",
      custtotal: 0,
      loading: false,
      items: [],
      // bkmenu: null,
      ordertmp: [],
      anime: true,
      columnNum: 2,
    };
  },
  async mounted() {
    // console.log("BKMenu.monted");
    // await this.init();
    // this.gLoading();
    // await this.refresh();
    // this.gClear();
    // setInterval(() => {
    //   this.refresh();
    // }, 60 * 1000);
  },
  methods: {
    getBtnText() {
      if (this.hasData()) return "確認傳送";
      return "請依座位選擇餐點";
    },
    hasData() {
      let array = this.ordertmp.filter((r) => r.Qty > 0);
      if (array.length > 0) return true;
      return false;
    },
    clear() {
      let count = Number(this.custTotal);

      if (count < 1) {
        count = 1;
        this.columnNum = 1;
      }
      // if (count == 1) this.columnNum = 1;
      this.ordertmp = [
        { ItemName: "#1", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#2", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#3", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#4", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#5", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#6", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#7", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#8", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#9", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#10", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#11", Qty: 0, Price1: 0, Groups: [] },
        { ItemName: "#12", Qty: 0, Price1: 0, Groups: [] },
      ];

      this.ordertmp = this.ordertmp.slice(0, count);
      // console.log(animals.slice(2));
      // this.ordertmp = this.ordertmp.map((r, index) => {
      //   return index < count;
      // });
    },
    async send(pTblName, pOrdertmp) {
      try {
        this.gLoading();
        let ordertmp = JSON.parse(JSON.stringify(pOrdertmp));
        for (let i = 0; i < ordertmp.length; i++) {
          console.log(i, ordertmp[i]);
          ordertmp[i].Groups.splice(0, 0, this.getTableTag("#" + (i + 1)));
        }
        ordertmp = ordertmp.filter((r) => r.Qty > 0);
        // ordertmp = ordertmp.filter((r) => r.Qty > 0);
        console.log("ordertmp", ordertmp);

        ordertmp.forEach((ot) => {
          ot.Groups.forEach((g) => {
            g.options = g.options.filter((o) => o.ItemName != "");
          });
        });

        // array = array.filter((r) => r.Qty > 0);
        // array = array.filter((r) => r.ItemName.toString().trim() != "");

        var query = {
          tblname: pTblName,
          ordertmp: ordertmp,
        };

        this.gSure("確認傳送")
          .then(async () => {
            // console.log("query...", query);
            let res = await this.apiSendOrder(query);
            // console.log("res...", res);
            // this.gMsgbox(res.data).then(() => {
            //   this.visible = false;
            //   this.$emit("ok");
            // });

            if (res.data == "BK35ORDERB00000000")
              this.gMsgbox(pTblName + "傳送完成").then(() => {
                this.visible = false;
                this.$emit("ok");
              });
            else this.gMsgbox(JSON.stringify(res.data), "傳送失敗").then(() => {});
          })
          .catch(() => {});
        // await this.refresh();
        // var res = await this.apiOpenTbl(query);
        // console.log(res);
        //
        // this.gMsgbox(res.data).then(() => {
        //   // query.ordertmp = ordertmp;
        // });

        // this.$refs.rOpenTable.close();
      } catch (error) {
        console.log(error);
        this.gMsgbox(error);
      } finally {
        this.gClearLoading();
      }
    },

    getTableTag(pTag) {
      //產生一個AN群組，存放座位號碼
      let group = {
        id: "",
        text: "",
        type: "AN",
        limit: 1,
        lock: true,
        num: false,
        remark: "",
        options: [
          {
            TypeNo: 1,
            ItemNo: 1,
            ItemName: pTag,
            ItemType: "-",
            Price1: 0,
            Price2: 0,
            Price3: 0,
            KPtype: "",
            OpenCode: "N",
            ImgFile: "",
            ItemCode: "",
            AvailTime: "",
            CtrlFlag: "",
            Price1Cap: "",
            Price2Cap: "",
            Price3Cap: "",
            DispName: pTag,
            Groups: [],
            Qty: true,
            DefaultQty: 0,
          },
        ],
      };
      return group;
    },
    show() {
      console.log("show");
      this.clear();
      this.visible = true;
    },

    setItem(pIndex, pObj) {
      console.log("setItem", pIndex, pObj);
      // this.ordertmp[pIndex] = pObj;
      // this.ordertmp[pIndex]= pObj;
      this.ordertmp.splice(pIndex, 1, pObj);
    },
    // allowSub() {
    //   if (this.custtotal > 0) {
    //     return true;
    //   }
    //   return false;
    // },
    cmd0() {
      this.custtotal--;
    },
    cmd1() {
      this.custtotal++;
    },
    add(pItem) {
      pItem.qty++;
    },
    sub(pItem) {
      pItem.qty--;
      if (pItem.qty < 0) pItem.qty = 0;
    },
    close() {
      this.obj = {};
      this.visible = false;
    },
    // async init() {
    //   try {
    //     // var res = await this.apiGetBKMenu();
    //     // this.bkmenu = res.data;
    //     // let extitem = this.bkmenu.extitem;
    //     // if (extitem[0]) this.items.push(extitem[0]);
    //     // if (extitem[1]) this.items.push(extitem[1]);
    //   } catch (error) {
    //     console.log(error.toString());
    //   }
    // },
  },
};
</script>
